import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProjectChecklistComponent } from './project-checklist.component';

const routes: Routes = [
  {
    path: '',
    component: ProjectChecklistComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProjectChecklistRoutingModule { }
